import { render, staticRenderFns } from "./business_organization.vue?vue&type=template&id=0a5278c0&scoped=true"
import script from "./business_organization.vue?vue&type=script&lang=js"
export * from "./business_organization.vue?vue&type=script&lang=js"
import style0 from "./business_organization.vue?vue&type=style&index=0&id=0a5278c0&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a5278c0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0a5278c0')) {
      api.createRecord('0a5278c0', component.options)
    } else {
      api.reload('0a5278c0', component.options)
    }
    module.hot.accept("./business_organization.vue?vue&type=template&id=0a5278c0&scoped=true", function () {
      api.rerender('0a5278c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dms/views/terminal/product-score-rules/form/components/business_organization.vue"
export default component.exports